<template>
  <div class="d-flex flex-column align-items-center">
    <div class="matches-container w-100">
      <div v-for="match in filteredMatches" :key="match.match_id" class="d-flex justify-content-center">
        <MatchCardComponent :match="match" @edit-match="openEditMatchScore" />
      </div>
      <!-- EditMatchScore Modal -->
      <div class="modal fade" id="editMatchScoreModal" tabindex="-1" aria-labelledby="editMatchScoreModalLabel" aria-hidden="true">
        <div class="modal-dialog">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="editMatchScoreModalLabel">試合結果編集</h5>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <EditMatchScoreFormComponent :match="editingMatch" :matchKey="selectedMatchKey" v-if="editingMatch"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterComponent @doFetch="doFetch"/>
    <SearchFormComponent @doRealtimeSearch="doRealtimeSearch"/>
  </div>
</template>

<script setup>
import { ref, onMounted, computed } from 'vue'
import { useRouter } from 'vue-router'
import { Modal } from 'bootstrap'
import MatchCardComponent from '@/components/MatchCardComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'
import SearchFormComponent from '@/components/SearchFormComponent.vue'
import EditMatchScoreFormComponent from '@/components/EditMatchScoreFormComponent.vue'
import Firebase from "@/firebase-settings/index.js"
import { ref as fbRef, get, child, getDatabase, onValue, query, orderByChild, startAt, endAt } from "firebase/database"

const db = getDatabase()
const realtimeMatches = ref({})
const realtime1 = ref({})
const realtime2 = ref({})
const realtime3 = ref({})
const realtime4 = ref({})
const teams = ref({})
const selectedMatch = ref(null)
const selectedMatchKey = ref('')
const editingMatch = ref(null)

// 時間順にソートされた試合リスト
const sortedMatches = computed(() => {
  const matches = Object.values(realtimeMatches.value)
  return matches.sort((a, b) => parseInt(a.timetable_index) - parseInt(b.timetable_index))
})

// フィルタリングされた試合リスト
const openEditMatchScore = (event_id, match_no) => {
  selectedMatchKey.value = event_id + "-" + match_no
  const dbRef = fbRef(db)
  get(child(dbRef, '/2026-summer/matches/' + event_id + "-" + match_no))
    .then((snapshot) => {
      if (snapshot.exists()) {
        editingMatch.value = snapshot.val()
        const modal = new Modal(document.getElementById('editMatchScoreModal'))
        modal.show()
      } else {
        console.warn("Not found - match:" + event_id + "-" + match_no)
      }
    })
}

const filteredMatches = computed(() => {
  const eventRegex = new RegExp(createSelectedEventIdRegex(), "i")
  const filterConditionTeam = getFilterConditionTeam()

  return sortedMatches.value.filter(match => {
    const matchesEventId = eventRegex.test(match.event_id.toLowerCase())
    if (!filterConditionTeam) return matchesEventId

    const matchesTeam = [
      match.left_team_id_1,
      match.left_team_id_2,
      match.right_team_id_1,
      match.right_team_id_2
    ].includes(filterConditionTeam)

    return matchesEventId && matchesTeam
  })
})

// 検索条件に基づいて試合をフィルタリング
const doRealtimeSearch = () => {
  realtimeMatches.value = { ...realtime1.value, ...realtime2.value, ...realtime3.value, ...realtime4.value }
    localStorage.setItem('matches', JSON.stringify(realtimeMatches.value));
    const eventRegex = new RegExp(createSelectedEventIdRegex(), "i");
    const filterConditionTeam = getFilterConditionTeam();

    if (filterConditionTeam) {
        realtimeMatches.value = Object.fromEntries(
            Object.entries(realtimeMatches.value)
            .filter(([key, value]) =>
                (eventRegex.test(value.event_id.toLowerCase()))
                && ([filterConditionTeam].includes(value.left_team_id_1) || [filterConditionTeam].includes(value.left_team_id_2) || [filterConditionTeam].includes(value.right_team_id_1) || [filterConditionTeam].includes(value.right_team_id_2))
            )
            .sort(function (a, b) {
                if (a[1].timetable_index < b[1].timetable_index) { return -1 }
                if (a[1].timetable_index > b[1].timetable_index) { return 1 }
                // if (parseInt(a[1].start.replace(/:/g, ''), 10) < parseInt(b[1].start.replace(/:/g, ''), 10)) { return -1 }
                // if (parseInt(a[1].start.replace(/:/g, ''), 10) > parseInt(b[1].start.replace(/:/g, ''), 10)) { return 1 }
                // if (a[1].court < b[1].court) { return -1 }
                // if (a[1].court > b[1].court) { return 1 }
                if (a[0] < b[0]) { return -1 }
                if (a[0] > b[0]) { return 1 }
                return 0
            })
        );
    } else {
        realtimeMatches.value = Object.fromEntries(
            Object.entries(realtimeMatches.value)
            .filter(([key, value]) =>
                (eventRegex.test(value.event_id.toLowerCase()))
            )
            .sort(function (a, b) {
                if (parseInt(a[1].start.replace(/:/g, ''), 10) < parseInt(b[1].start.replace(/:/g, ''), 10)) { return -1 }
                if (parseInt(a[1].start.replace(/:/g, ''), 10) > parseInt(b[1].start.replace(/:/g, ''), 10)) { return 1 }
                if (a[1].court < b[1].court) { return -1 }
                if (a[1].court > b[1].court) { return 1 }
                if (a[0] < b[0]) { return -1 }
                if (a[0] > b[0]) { return 1 }
                return 0
            })
        );
    }
}

// 選択された条件に基づいてイベントIDの正規表現を作成
const createSelectedEventIdRegex = () => {
  const allCombinations = []

  const grade = JSON.parse(localStorage.getItem("filterConditionGrade") || "[]")
  const gender = JSON.parse(localStorage.getItem("filterConditionGender") || "[]")
  const group = JSON.parse(localStorage.getItem("filterConditionGroup") || "[]")

  if (grade.length === 0 && gender.length === 0 && group.length === 0) {
    allCombinations.push('')
  } else {
    for (const g of grade.length === 0 ? [''] : grade) {
      for (const gen of gender.length === 0 ? [''] : gender) {
        for (const grp of group.length === 0 ? [''] : group) {
          const combination = `${g}${gen}${grp}`
          allCombinations.push(combination.toUpperCase())
        }
      }
    }
  }

  return allCombinations.join('|') || '6*'
}

// 選択されたチームの条件を取得
const getFilterConditionTeam = () => {
  const jsonData = localStorage.getItem("filterConditionTeam")
  return jsonData ? JSON.parse(jsonData) : "";
}

onMounted(() => {
  establishConnection()
  fetchTeams()
})

// チームデータを取得
const fetchTeams = () => {
  const dbRef = fbRef(db)
  onValue(fbRef(db, '/2026-summer/teams'), (snapshot) => {
    if (snapshot.exists()) {
      teams.value = snapshot.val()
      localStorage.setItem('teams', JSON.stringify(snapshot.val()))
    } else {
      console.log('No data available')
    }
  }, (error) => {
    console.error(error)
  })
}

const establishConnection = () => {
  const matchesRef = fbRef(db, '/2026-summer/matches/')
  onValue(query(matchesRef, orderByChild('timetable_index'), startAt(900000), endAt(1145999)), (snapshot) => {
    realtime1.value = snapshot.val()
    updateMatches()
  })
  onValue(query(matchesRef, orderByChild('timetable_index'), startAt(1146000), endAt(1245999)), (snapshot) => {
    realtime2.value = snapshot.val()
    updateMatches()
  })
  onValue(query(matchesRef, orderByChild('timetable_index'), startAt(1246000), endAt(1445999)), (snapshot) => {
    realtime3.value = snapshot.val()
    updateMatches()
  })
  onValue(query(matchesRef, orderByChild('timetable_index'), startAt(1446000)), (snapshot) => {
    realtime4.value = snapshot.val()
    updateMatches()
  })
}

const openEditScoreForm = (event_id, match_no) => {
  selectedMatchKey.value = event_id + "-" + match_no
  const dbRef = fbRef(db)
  get(child(dbRef, '/2026-summer/matches/' + event_id + "-" + match_no))
    .then((snapshot) => {
      if (snapshot.exists()) {
        selectedMatch.value = snapshot.val()
      } else {
        console.warn("Not found - match:" + event_id + "-" + match_no)
      }
    })
}

const updateMatches = () => {
  realtimeMatches.value = { ...realtime1.value, ...realtime2.value, ...realtime3.value, ...realtime4.value }
}

const doFetch = () => {
  establishConnection()
}
</script>
